module.exports = __webpack_public_path__ + "img/study-mode-faq-1.480d6115.png";